import Storage from '@/assets/js/storage'
import { fetchSegmentAirport } from '@/apis/flight'
// import { defaultAirlines, defaultCitiesByAirline } from './defaultCities'

const hash = '1702995840101'
let fetchCache = null

async function fetchNewCities () {
  try {
    const res = await fetchSegmentAirport()
    if (res.length) {
      try {
        Storage.setItem('FLIGHT_CITIES', JSON.stringify(res), 24 * 3600000, hash)
        return res
      } catch (error) {
        return res
      }
    } else {
      return null
    }
  } catch (e) {
    return null
  }
}

/**
 * @description 获取航班城市列表
 * @return {Promise.<*>}
 */
export async function flightCities () {
  // NOTE: 9H - 国际固定航线
  // const airline = window.__MICRO_ROOT__?.airline
  // if (defaultAirlines.includes(airline)) {
  //   const cities = defaultCitiesByAirline.find(item => { return item.airline === airline })?.cities
  //   return cities
  // }
  const cityData = Storage.getItem('FLIGHT_CITIES', hash)
  let cityParsed
  if (cityData) {
    try {
      cityParsed = JSON.parse(cityData)

      if (!cityParsed.length) { // 如果返回结果解析不正确，则remove storage
        Storage.removeItem('FLIGHT_CITIES')
        cityParsed = null
      }
    } catch (e) {
      Storage.removeItem('FLIGHT_CITIES')
      cityParsed = null
    }

    return cityParsed
  } else {
    if (!fetchCache) {
      fetchCache = fetchNewCities()
    }

    return fetchCache
  }
}
